const compareProjectBoardQueryObjects = (
  prevQueryObject,
  currentQueryObject
) => {
  return prevQueryObject?.search === currentQueryObject?.search;
};

export default compareProjectBoardQueryObjects;
